"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INetStateDependencySchema = exports.IModeDependencySchema = void 0;
exports.isModeDependency = isModeDependency;
exports.isNetStateDependency = isNetStateDependency;
const zod_1 = require("zod");
const AbsoluteCharacteristicValue_1 = require("./AbsoluteCharacteristicValue");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
exports.IModeDependencySchema = zod_1.default.object({
    type: zod_1.default.literal('mode'),
    modeGlobalId: zod_1.default.string(),
    state: zod_1.default.union([zod_1.default.boolean(), zod_1.default.literal('x')]),
});
function isModeDependency(d) {
    return d.type === 'mode';
}
function isNetStateDependency(d) {
    return d.type === 'net';
}
exports.INetStateDependencySchema = zod_1.default.object({
    type: zod_1.default.literal('net'),
    netName: zod_1.default.string(),
    characteristic: zod_1.default.lazy(() => BoundaryCharacteristic_1.BoundaryCharacteristicSchema),
    value: zod_1.default.lazy(() => AbsoluteCharacteristicValue_1.AbsoluteCharacteristicValueSchema),
});
//# sourceMappingURL=IModeDependency.js.map